"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWrapper = exports.StyledEmbeddedContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledEmbeddedContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: auto;
`;
exports.StyledWrapper = styled_components_1.default.div `
  max-height: 100%;
  overflow-y: auto;
  ${({ theme, isEmbedded }) => (0, styled_components_1.css) `
    padding-top: ${ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
    padding-bottom: ${isEmbedded
    ? 0
    : ui_common_components_1.utils.rem(theme.Components.ToolBar.drawerGap)};
    ${({ theme }) => theme.Scrollbar.Panel};
    border-top: ${ui_common_components_1.utils.rem(theme.Border.Size.Small)} solid
      ${theme.Color.Neutrals.Border};
  `}
`;
//# sourceMappingURL=AiImageOverview.style.js.map